import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  selected: boolean;
  title: string;
}

interface Emit {
  (event: 'select'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioButton',
  props: {
    selected: { type: Boolean },
    title: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function select(): void {
  emit('select');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex cursor-pointer",
    onClick: select
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["size-5 rounded-xl mr-2 flex-shrink-0", props.selected ? 'border-5 border-green-500' : 'border-1 border-neutral2-400'])
    }, null, 2 /* CLASS */),
    _createTextVNode(" " + _toDisplayString(props.title), 1 /* TEXT */)
  ]))
}
}

})